(function($) {

    $(window).on('load', function(){
        //$('.js-sitprldr').fadeOut();
    });

    $(function(){

        let video_logo = $("#sf-video-logo");
        if(video_logo.length > 0) {
            let vltmr = setTimeout(function(){
                video_logo.get(0).play();
                clearTimeout(vltmr);
            }, 600);
        }

        $(video_logo).mouseenter(function(){
            $(this).get(0).currentTime = 0;
            $(this).get(0).play();
        }).mouseleave(function() {
            $(this).get(0).pause();
        });

        // Check if WP Login Panel Is Available To Adjust Custome Header.
        let wp_login_header = $("#wpadminbar");
        if(wp_login_header.length !== 0) {
            $('html').addClass('wp-enabled-header');
        } else {
            $('html').removeClass('wp-enabled-header');
        }

        // Desktop Search Toggle.
        $('.js-trigsrch-desk').on('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            let srch_cont = $(this).parent().find('.js-srchcont-pos');
            let isActive = $(this).hasClass('active');
            if(!isActive) {
                $(this).addClass('active');
                $(srch_cont).fadeIn();
            } else {
                $(this).removeClass('active');
                $(srch_cont).fadeOut();
            }
        });

        // Mobile Search Toggle.
        $('.js-trigsrch-mobi').on('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            let srch_cont_mob = $(this).parent();
            let scmb_gp = $(this).parents('.js-search-outer-mob');
            let isActive = $(this).hasClass('active');
            if(!isActive) {
                $(this).addClass('active');
                $(srch_cont_mob).addClass('show');
                $(scmb_gp).addClass('visible');
            } else {
                $(this).removeClass('active');
                $(srch_cont_mob).removeClass('show');
                let st_1 = setTimeout(function(){
                    $(scmb_gp).removeClass('visible');
                    clearTimeout(st_1);
                }, 600);
            }
        });

        // Desktop New Search Toggle.
        $('.js-sstlink--v2').on('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            let srch_cont_mob = $(this).parent();
            let scmb_gp = $(this).parents('.js-srchgp');
            let isActive = $(this).hasClass('active');
            let menu = $('.js-snnew--v2');
            let nav_v2 = $('.site-nav--v2');
            let nav_v2_gp = $('.js-site-nav--v2');
            if(!isActive) {
                menu.addClass('invisible-v2');
                $(this).addClass('active');
                $(srch_cont_mob).addClass('show');
                $(scmb_gp).addClass('visible');
                nav_v2_gp.addClass('expanded');
                nav_v2.addClass('expanded');
                // nav_v2.css({
                //     width: 100+'%'
                // });
            } else {
                $(this).removeClass('active');
                $(srch_cont_mob).removeClass('show');
                let st_1 = setTimeout(function(){
                    $(scmb_gp).removeClass('visible');
                    clearTimeout(st_1);
                    nav_v2.removeClass('expanded');
                    nav_v2_gp.removeClass('expanded');
                }, 400);
                // nav_v2.css({
                //     width: 50+'%'
                // });
                menu.removeClass('invisible-v2');
            }
        });

        $('.js-mmtglbtn').on('click', function(e){
            e.preventDefault();
            // e.stopPropagation();
            let isActive = $(this).hasClass('active');
            let menu_v2 = $('.js-site-nav--v2');
            let menu_bkdrp = $('.js-mnubkdrp');
            $("body").css('overflow','hidden');
            if(!isActive) {
                $(this).addClass('active');
                // menu_v2.addClass('active');
                menu_v2.fadeIn();
                menu_bkdrp.show();
            } else {
                $(this).removeClass('active');
                // menu_v2.removeClass('active');
                menu_v2.fadeOut();
                menu_bkdrp.hide();
                $("body").css("overflow", "visible");
            }
        });

        $('.js-snnew-mob--v2 .dropdown .dropdown-toggle').on('click', function(e){
            // e.preventDefault();
            e.stopPropagation();
            let drpSHow = $(this).hasClass('show');
            let nav_v2 = $('.site-nav--v2');
            let nav_v2_gp = $('.js-site-nav--v2');
            let all_links = $('.nav-link');
            let srch_mob = $('.js-srchgp.mobile');
            if(drpSHow) {
                nav_v2_gp.addClass('expanded');
                nav_v2.addClass('expanded');
                all_links.hide();
                $(this).show();
                srch_mob.hide();
            } else {
                nav_v2.removeClass('expanded');
                let st_1 = setTimeout(function(){
                    nav_v2_gp.removeClass('expanded');
                    clearTimeout(st_1);
                }, 400);
                all_links.show();
                srch_mob.show();
            }
        });

        // If User Click On Document Anywhere.
        $('html').on('click', function(){
            // Hide Desktop Search.
            $('.js-trigsrch-desk').removeClass('active');
            let srch_cont = $('.js-trigsrch-desk').parent().find('.js-srchcont-pos');
            $(srch_cont).fadeOut();

            // Hide Mobile Search.
            $('.js-trigsrch-mobi').removeClass('active');
            let srch_cont_mob = $('.js-trigsrch-mobi').parent();
            let scmb_gp = $('.js-trigsrch-mobi').parents('.js-search-outer-mob');
            $(srch_cont_mob).removeClass('show');
            //$(scmb_gp).removeClass('visible');
            let st_1 = setTimeout(function(){
                $(scmb_gp).removeClass('visible');
                clearTimeout(st_1);
            }, 600);

            // Misc
            // $('.js-desk-cont').fadeIn();
            let wiw = $(window).width();
            if(wiw > 767) {
                // $('.js-catopts').fadeIn();
            }

            // Hide New Desktop Search.
            $('.js-sstlink--v2').removeClass('active');
            let srch_cont_mob_v2 = $('.js-sstlink--v2').parent();
            let scmb_gp_v2 = $('.js-sstlink--v2').parents('.js-srchgp');
            let menu_v2 = $('.js-snnew--v2');
            let nav_v2 = $('.site-nav--v2');
            let nav_v2_gp = $('.js-site-nav--v2');
            $(srch_cont_mob_v2).removeClass('show');
            nav_v2.removeClass('expanded');
            let st_2 = setTimeout(function(){
                $(scmb_gp_v2).removeClass('visible');
                
                nav_v2_gp.removeClass('expanded');
                clearTimeout(st_2);
            }, 400);
            // nav_v2.css({
            //     width: 50+'%'
            // });
            menu_v2.removeClass('invisible-v2');

            let all_links = $('.nav-link');
            let srch_mob = $('.js-srchgp.mobile');
            if(wiw < 768) {
                all_links.show();
                srch_mob.show();
            }
        });

        $('.js-srchcont-pos, .js-srchgp').on('click', function(e){
            e.stopPropagation();
        });

    }); // <-- End of DOM.Ready();

})( jQuery );